import React, { FC, ReactElement } from 'react';
import { Button, Modal } from 'react-bootstrap';
import withLocalization from '../../hoc/withLocalization';
import '../Header/Header.scss';

const SessionExpired: FC<any> = (props: any): ReactElement => {
  const { onLoginClicked, localize } = props;
  return (
    <Modal
      dialogClassName="modal-custom-session"
      show={true}
      backdrop="static"
      keyboard="false"
      animation={false}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        {localize('preview-sales-engine.static-content.copy.Labels.labels#session-expire-message')}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" active onClick={onLoginClicked}>
          {localize('preview-sales-engine.static-content.copy.Labels.labels#session-expire-button-text')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default withLocalization(SessionExpired);
